import documentsAPI from '../api'

export async function getDocumentTemplates({ page, limit }) {
	const { data } = await documentsAPI.get(
		`/templates/?per_page=${limit}&page=${page}`
	)

	return data
}

export async function getDocumentsByStatus() {
	const { data } = await documentsAPI.get(`/workflow/documents-by-status`)

	return data
}

export const downloadDocumentDocxService = async (documentId, versionId) => {
	const versionParam = versionId ? `?version=${versionId}` : ''
	const response = await documentsAPI.get(
		`/documents/${documentId}/docx${versionParam}`
	)
	return response
}

export async function getNotificationLog(documentId) {
	const documentParam = documentId ? `?document_id=${documentId}` : ''
	const { data } = await documentsAPI.get(
		`/documents/notifications${documentParam}`
	)

	return data
}
